<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { ChevronRight } from "lucide-vue-next";
import { PaginationNext, type PaginationNextProps } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { buttonVariants } from "@/shared/components/ui/button";

const props = defineProps<
  PaginationNextProps & {
    class?: HTMLAttributes["class"];
  }
>();
</script>

<template>
  <PaginationNext
    v-bind="props"
    :class="cn(buttonVariants({ variant: 'ghost', size: 'default' }), props.class)"
  >
    <slot>
      Next
      <ChevronRight class="size-4 shrink-0" />
    </slot>
  </PaginationNext>
</template>
